import React from "react";
import { useFormContext } from "react-hook-form";
import { FormSelectField } from "@components-shared/desktop/inputs";
import { validateCountry } from "@utils";
import { CountryDataType } from "@data-types/membership/registration";
import { useTranslation } from "react-i18next";

export default function RegistrationCountry(props: {
	countryData: CountryDataType[] | null;
	labelClassName?: string;
}) {
	const { getValues } = useFormContext();
	const { t } = useTranslation("registration");
	const { countryData, labelClassName } = props;

	return (
		<FormSelectField
			className="form__field"
			name="countryId"
			label={t("COUNTRY_LABEL")}
			labelClassName={labelClassName}
			placeholder={t("COUNTRY_PLACEHOLDER")}
			dropdownData={countryData}
			validate={{
				isCountryValidDependantOnDoB: (value: string) =>
					validateCountry(getValues("dob"), countryData, value),
			}}
			required
		/>
	);
}
